export class Product {
  public id: number = null;
  public title: string = null;
  public description: string = null;
  public reference: string = null;
  public price_ht: number = null;
  public model_mission_id: number = null;
  public mission_model_title: string = null;
  public max_number_of_mission: number = null;
  public max_number_of_task: number = null;
  public status: string = null;
  public created_at: string = null;

  constructor(data?: any) {
    if (data) this.import(data);
  }

  import(data: any) {
    for (const key in data) {
      if (this.hasOwnProperty(key)) {
        this[key] = data[key];
      }
    }
  }
}
